import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { hideVisually } from 'polished';
import { black, red, blue20, grey40, grey60 } from 'Styles/colors';
import { fontBody } from 'Styles/fonts';

export const DisplayContainer = styled.label`
  padding: 0 1px;
  ${fontBody(32)};
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  border-style: solid;
  border-color: ${ifProp('hasError', red, grey60)};
  border-width: ${ifProp('hasError', '2px', '1px')};
  color: ${black};
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  pointer-events: none;
`;

export const FieldDescription = styled.span`
  ${hideVisually()};
`;

export const DisplayNum = styled.div`
  padding: 4px 0;
  flex: 1;
  height: 100%;
  background-color: ${ifProp('isActive', grey40)};
  border-right: 1px solid ${grey40};
  border-left: 1px solid ${grey40};
  margin-right: -1px;
  align-items: center;
  justify-content: center;
  display: flex;

  &:first-of-type {
    border-left: 0;
  }

  &:last-of-type {
    border-right: 0;
    margin-right: 0;
  }
`;

export const Input = styled.input`
  border: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  cursor: pointer;
  color: transparent;
  caret-color: transparent;

  &:focus {
    outline: none;
  }
`;

export const ConfirmationCodeInput = styled.div`
  position: relative;
  height: 56px;

  ${({ hasError }) => {
    if (hasError) {
      return css`
        ${DisplayContainer} {
          padding: 0;
        }

        ${DisplayNum} {
          padding: 3px 0;
        }
      `;
    }
  }}

  ${Input}:focus ~ ${DisplayContainer} {
    border: solid 2px ${blue20};
    padding: 0;

    ${DisplayNum} {
      padding: 3px 0;
    }
  }
`;

export const Error = styled.div`
  ${fontBody(16)};
  color: ${red};
  margin: 0;
  margin-top: 8px;
  padding: 4px 16px;
`;
